import { Component, Input, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Position } from 'src/app/models/position.model';

@Component({
  selector: 'app-position-questions',
  templateUrl: './position-questions.component.html',
  styleUrl: './position-questions.component.scss'
})
export class PositionQuestionsComponent {

  public expanded = false;
  public loaded = false;
  
  @Input()
  public position: Position;

  @ViewChild('panel')
  public panel: MatExpansionPanel;

  constructor() {
    
    
  }


}
